import { Capabilities, PlatformType } from "@spawn/common";
import { IAssetHandle, Orientation, Sprite, TextureResource, asset, view } from "@spawn/core";
import { SlideView } from "@spawn/slot-machine";
import Color from "color";
import Victor from "victor";
import { Layout } from "@spawn/nrg-games-core";

@view
export class LogoSlideView extends SlideView {
	@asset(TextureResource) public readonly logoTexture!: IAssetHandle<TextureResource>;
	@asset(TextureResource) public readonly loadingChar!: IAssetHandle<TextureResource>;

	private readonly logo: Sprite;
	private readonly char: Sprite;

	constructor() {
		super({
			options: {
				layout: Layout.center(),
			},
			dimmingOptions: {
				color: new Color("#331100"),
				alpha: 0.2,
			},
		});

		this.logo = new Sprite(this.logoTexture(), Layout.center());
		this.char = new Sprite(this.loadingChar(), Layout.center());

		this.addChild(this.char, this.logo);
		this.onOrientationChange();

		this.subscriptions.push(this.screenOrientationService.orientationChanged$.subscribe(() => this.onOrientationChange()));
	}

	private onOrientationChange(): void {
		if (Capabilities.platformType === PlatformType.Desktop) {
			this.char.scale = new Victor(0.67, 0.67);
			this.char.position = new Victor(-625, 100);
			this.logo.scale = new Victor(0.8, 0.8);
		} else if (this.screenOrientationService.orientation === Orientation.Portrait) {
			const yOffset = this.scaleProvider.applicationResolution.y * 0.05;
			this.logo.position = new Victor(0, yOffset);
			this.char.position = new Victor(-30, yOffset + 80);

			// Adjust spacing for different portrait aspect ratios
			const scaleMultiplier = this.scaleProvider.aspectRatio > 0.6 ? 0.9 : 1; // 0.9 for narrow screens, 1 otherwise
			this.logo.scale = new Victor(scaleMultiplier, scaleMultiplier);
			this.char.scale = new Victor(scaleMultiplier, scaleMultiplier);
		} else {
			this.char.scale = new Victor(0.74, 0.74);
			this.char.position = new Victor(-650, 130);
			this.logo.position = new Victor(0, 0);
		}
	}
}
